<template>
  <div class="Income-and-expenditure">
    <div class="left">
      <span>年收入:￥{{incomeSum}}</span>
      <v-chart v-if="incomeOptionShow"
               :options="incomeOption"
               style="width:100%;height:200px;"></v-chart>
      <span>年支出:￥{{expenditureSum}}</span>
      <v-chart v-if="expenditureOptionShow"
               :options="expenditureOption"
               style="width:100%;height:200px;"></v-chart>
    </div>
    <div class="right">
      <el-container class="top">
        <el-header class="first-line"
                   style="height: 38px;">
          <span>年收入(元)</span>
          <span>本人</span>
          <span>配偶</span>
        </el-header>
        <el-main class="content">
          <div v-for="(v,i) in incomeTableData"
               :key="i"
               :class="i%2!==0?'background':''"
               class="table">
            <span>{{v.name}}</span>
            <span v-if="editShow"
                  :class="v.name==='金融投资收入'?'oneself':''"
                  style="width:120px;text-align: right;">{{v.oneself|addMoneyFilter}}</span>
            <el-input v-else
                      v-model="v.oneself"
                      placeholder="请输入内容"
                      style="width:120px;"
                      :class="v.name==='金融投资收入'?'oneself':''"></el-input>
            <span v-if="editShow"
            style="width:120px;text-align: right;">{{v.spouse|addMoneyFilter}}</span>
            <el-input v-else-if="v.spouse!=='-'"
                      v-model="v.spouse"
                      placeholder="请输入内容"
                      style="width:120px;"></el-input>
            <span v-else
                  style="width:120px;text-align: right;">{{v.spouse|addMoneyFilter}}</span>
          </div>
        </el-main>
      </el-container>
      <el-container class="bottom">
        <el-header class="first-line"
                   style="height: 38px;">
          <span>年支出(元)</span>
          <span>本人</span>
          <span>配偶</span>
        </el-header>
        <el-main class="content">
          <div v-for="(v,i) in expenditureTableData"
               :key="i"
               :class="i%2!==0?'background':''"
               class="table">
            <span>{{v.name}}</span>
            <span v-if="editShow"
                  :class="v.name==='贷款及利息支出'?'oneself':''"
                  style="width:120px;text-align: right;">{{v.oneself|addMoneyFilter}}</span>
            <el-input v-else
                      v-model="v.oneself"
                      placeholder="请输入内容"
                      style="width:120px;"
                      :class="v.name==='贷款及利息支出'?'oneself':''"></el-input>
            <span v-if="editShow"
            style="width:120px;text-align: right;">{{v.spouse|addMoneyFilter}}</span>
            <el-input v-else-if="v.spouse!=='-'"
                      v-model="v.spouse"
                      placeholder="请输入内容"
                      style="width:120px;"></el-input>
            <span v-else
                  style="width:120px;text-align: right;">{{v.spouse|addMoneyFilter}}</span>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cis: JSON.parse(sessionStorage.getItem('customer')).cis,
      // 编辑开关
      editShow: true,
      // 年收入数据
      incomeOptionShow: false,
      incomeOption: {},
      incomeSum: 0,
      incomeTableData: [
        {
          name: '工资收入',
          oneself: '-',
          spouse: '-',
        },
        {
          name: '金融投资收入',
          oneself: '-',
          spouse: '-',
        },
        {
          name: '其他收入',
          oneself: '-',
          spouse: '-',
        },
      ],
      // 年支出数据
      expenditureOptionShow: false, // 显示开关
      expenditureOption: {}, // 饼图数据
      expenditureSum: 0,
      expenditureTableData: [
        {
          name: '日常支出',
          oneself: '-',
          spouse: '-',
        },
        {
          name: '贷款及利息支出',
          oneself: '-',
          spouse: '-',
        },
        {
          name: '其他支出',
          oneself: '-',
          spouse: '-',
        },
      ],
    };
  },
  mounted() {
    this.getCustIncomeMsg();
    this.getCustExpendMsg();
  },
  methods: {
    // 查询客户收入信息
    getCustIncomeMsg() {
      const params = {
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.getIncome, params)
        .then((res) => {
          console.log(res, '查询客户收入信息');
          for (let i = 0; i < res.data.custIncomeInfos.length; i++) {
            if (res.data.custIncomeInfos[i].isSelf === '0') {
              for (let y = 0; y < this.incomeTableData.length; y++) {
                if (this.incomeTableData[y].name === '工资收入') {
                  this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].salaryIncome;
                }
                if (this.incomeTableData[y].name === '金融投资收入') {
                  this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].investIncome;
                }
                if (this.incomeTableData[y].name === '其他收入') {
                  this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].otherIncome;
                }
              }
            } else {
              for (let y = 0; y < this.incomeTableData.length; y++) {
                if (this.incomeTableData[y].name === '工资收入') {
                  this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].salaryIncome;
                }
                if (this.incomeTableData[y].name === '金融投资收入') {
                  this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].investIncome;
                }
                if (this.incomeTableData[y].name === '其他收入') {
                  this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].otherIncome;
                }
              }
            }
          }
          this.incomeSum = res.data.custIncomeInfoListDTO.custIncomeTotal;
          const list = [];
          if (res.data.custIncomeInfoListDTO.otherIncomeTotal > 10000 || res.data.custIncomeInfoListDTO.investIncomeTotal > 10000 || res.data.custIncomeInfoListDTO.salaryIncomeTotal > 10000) {
            list.push(res.data.custIncomeInfoListDTO.otherIncomeTotal / 10000);
            list.push(res.data.custIncomeInfoListDTO.investIncomeTotal / 10000);
            list.push(res.data.custIncomeInfoListDTO.salaryIncomeTotal / 10000);
            this.incomePieChart(list, 1);
          } else {
            list.push(res.data.custIncomeInfoListDTO.otherIncomeTotal);
            list.push(res.data.custIncomeInfoListDTO.investIncomeTotal);
            list.push(res.data.custIncomeInfoListDTO.salaryIncomeTotal);
            this.incomePieChart(list, 2);
          }
        });
    },
    // 查询客户支出信息
    getCustExpendMsg() {
      const params = {
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.getExpend, params)
        .then((res) => {
          console.log(res, '查询客户支出信息');
          for (let i = 0; i < res.data.custExpendInfo.length; i++) {
            if (res.data.custExpendInfo[i].isSelf === '0') {
              for (let y = 0; y < this.expenditureTableData.length; y++) {
                if (this.expenditureTableData[y].name === '日常支出') {
                  this.expenditureTableData[y].oneself = res.data.custExpendInfo[i].dailyExpend;
                }
                if (this.expenditureTableData[y].name === '贷款及利息支出') {
                  this.expenditureTableData[y].oneself = res.data.custExpendInfo[i].loanInterestExpend;
                }
                if (this.expenditureTableData[y].name === '其他支出') {
                  this.expenditureTableData[y].oneself = res.data.custExpendInfo[i].otherExpend;
                }
              }
            } else {
              for (let y = 0; y < this.expenditureTableData.length; y++) {
                if (this.expenditureTableData[y].name === '日常支出') {
                  this.expenditureTableData[y].spouse = res.data.custExpendInfo[i].dailyExpend;
                }
                if (this.expenditureTableData[y].name === '贷款及利息支出') {
                  this.expenditureTableData[y].spouse = res.data.custExpendInfo[i].loanInterestExpend;
                }
                if (this.expenditureTableData[y].name === '其他支出') {
                  this.expenditureTableData[y].spouse = res.data.custExpendInfo[i].otherExpend;
                }
              }
            }
          }
          this.expenditureSum = res.data.custExpendInfoListDTO.custExpendTotal;
          const list = [];
          if (res.data.custExpendInfoListDTO.otherExpendTotal > 10000 || res.data.custExpendInfoListDTO.loanInterestExpendTotal > 10000 || res.data.custExpendInfoListDTO.dailyExpendTotal > 10000) {
            list.push(res.data.custExpendInfoListDTO.otherExpendTotal / 10000);
            list.push(res.data.custExpendInfoListDTO.loanInterestExpendTotal / 10000);
            list.push(res.data.custExpendInfoListDTO.dailyExpendTotal / 10000);
            this.expenditurePieChart(list, 1);
          } else {
            list.push(res.data.custExpendInfoListDTO.otherExpendTotal);
            list.push(res.data.custExpendInfoListDTO.loanInterestExpendTotal);
            list.push(res.data.custExpendInfoListDTO.dailyExpendTotal);
            this.expenditurePieChart(list, 2);
          }
        });
    },
    // 收入饼图
    incomePieChart(list, i) {
      this.incomeOption = {
        title: {
          text: '',
          subtext: '',
        },
        tooltip: {},
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
        },

        xAxis: {
          name: i === 1 ? '万元' : '元',
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          data: ['其他收入', '金融投资收益', '工资收入'],
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: list,
            itemStyle: {
              normal: {
                color: '#1E88FF',
              },
            },
          },
        ],
      };
      this.incomeOptionShow = true;
    },
    // 支出饼图
    expenditurePieChart(list, i) {
      this.expenditureOption = {
        title: {
          text: '',
          subtext: '',
        },
        tooltip: {},
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
        },

        xAxis: {
          name: i === 1 ? '万元' : '元',
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          data: ['其他支出', '贷款及利息支出', '日常支出'],
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: list,
            itemStyle: {
              normal: {
                color: '#F96464',
              },
            },
          },
        ],
      };
      this.expenditureOptionShow = true;
    },
    // 修改财务信息
    preservation() {
      let incomeData = [];
      let expenditureData = [];
      if (this.incomeTableData[0].spouse === '-') {
        incomeData = [
          {
            isSelf: '0', // 是否本人，0本人，1配偶
            salaryIncome: this.incomeTableData[0].oneself, // 工资收入
            investIncome: this.incomeTableData[1].oneself, // 金融投资收入
            otherIncome: this.incomeTableData[2].oneself, // 其他收入
          },
        ];
      } else {
        incomeData = [
          {
            isSelf: '0', // 是否本人，0本人，1配偶
            salaryIncome: this.incomeTableData[0].oneself, // 工资收入
            investIncome: this.incomeTableData[1].oneself, // 金融投资收入
            otherIncome: this.incomeTableData[2].oneself, // 其他收入
          },
          {
            isSelf: '1', // 是否本人，0本人，1配偶
            salaryIncome: this.incomeTableData[0].spouse, // 工资收入
            investIncome: this.incomeTableData[1].spouse, // 金融投资收入
            otherIncome: this.incomeTableData[2].spouse, // 其他收入
          },
        ];
      }
      if (this.expenditureTableData[0].spouse === '-') {
        expenditureData = [
          {
            isSelf: '0', // 是否本人，0本人，1配偶
            dailyExpend: this.expenditureTableData[0].oneself, // 日常支出
            loanInterestExpend: this.expenditureTableData[1].oneself, // 贷款及利息支出
            otherExpend: this.expenditureTableData[2].oneself, // 其他支出
          },
        ];
      } else {
        expenditureData = [
          {
            isSelf: '0', // 是否本人，0本人，1配偶
            dailyExpend: this.expenditureTableData[0].oneself, // 日常支出
            loanInterestExpend: this.expenditureTableData[1].oneself, // 贷款及利息支出
            otherExpend: this.expenditureTableData[2].oneself, // 其他支出
          },
          {
            isSelf: '1', // 是否本人，0本人，1配偶
            dailyExpend: this.expenditureTableData[0].spouse, // 日常支出
            loanInterestExpend: this.expenditureTableData[1].spouse, // 贷款及利息支出
            otherExpend: this.expenditureTableData[2].spouse, // 其他支出
          },
        ];
      }

      const parames = {
        data: {
          cis: this.cis,
          updateUser: '1', // 修改人
          custerIncomeInfoVOS: incomeData,
          custerExpendInfoVOS: expenditureData,
        },
      };
      this.$_post(this.$API.uptFinanceInfo, parames).then((res) => {
        if (res.errorCode === 'WP00035') {
          this.$message({
            message: res.errorMsg,
            type: 'success',
          });
          this.getCustIncomeMsg();
          this.getCustExpendMsg();
          this.incomeOptionShow = false;
          this.expenditureOptionShow = false;
        }
      });
    },
    edit(bool) {
      this.editShow = bool;
    },
  },
};
</script>
<style lang="scss">
.Income-and-expenditure {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .el-input__inner {
    width: 120px;
    height: 25px !important;
    line-height: 25px;
  }
  .left {
    width: 49%;
    span {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      position: relative;
      top: 30px;
      left: 45px;
    }
  }
  .right {
    width: 49%;
    .top {
      height: 160px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 40px;
      .first-line {
        padding: 12px 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          .oneself {
            position: relative;
            right: 14px;
          }
        }
      }
    }
    .bottom {
      height: 160px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 60px;
      .first-line {
        padding: 12px 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          .oneself {
            position: relative;
            right: 21px;
          }
        }
      }
    }
  }
}
</style>
